import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomIconInput from '@lyearn-team/frontend-components/dist/Input/CustomIconInput';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import SquareBorderButton from '@lyearn-team/frontend-components/dist/Button/SquareBorderButton';
import globalURL from 'helper/url';
import isEmail from 'validator/lib/isEmail';
import {
  Column,
  FixWidthColumn,
  CompanyPageWrapper,
  Heading,
  IntroText,
  ContactLyearnText,
  DomainWrapper,
  FixText
} from './styles';
import { validateNumber } from '../shared/static';
import { SignUpFields, SignUpErrors } from '../shared/consts';

export default class CompanySignup extends Component {
  static contextTypes = {
    getFeatureFlag: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      companyName: '',
      loading: false,
      domainName: '',
      email: '',
      phoneNumber: '',
      fieldStatus: {
        field: '',
        error: ''
      },
      success: false
    };
    this.companyInfo = '';
  }

  onFieldChange = field => e => {
    const { fieldStatus, success } = this.state;
    const status = { field: '', error: '' };
    if (success) {
      this.setState({ success: false });
    }
    switch (field) {
      case SignUpFields.NAME: {
        if (fieldStatus.field === SignUpFields.NAME) {
          this.setState({ fieldStatus: status });
        }
        this.setState({ fullName: e.target.value });
        break;
      }
      case SignUpFields.EMAIL: {
        if (fieldStatus.field === SignUpFields.EMAIL) {
          this.setState({ fieldStatus: status });
        }
        this.setState({ email: e.target.value });
        break;
      }
      case SignUpFields.COMPANY: {
        if (fieldStatus.field === SignUpFields.COMPANY) {
          this.setState({ fieldStatus: status });
        }
        this.setState({ companyName: e.target.value });
        break;
      }
      case SignUpFields.DOMAIN: {
        if (fieldStatus.field === SignUpFields.DOMAIN) {
          this.setState({ fieldStatus: status });
        }
        this.setState({ domainName: e.target.value });
        break;
      }
      case SignUpFields.NUMBER: {
        if (fieldStatus.field === SignUpFields.NUMBER) {
          this.setState({ fieldStatus: status });
        }
        this.setState({ phoneNumber: e.target.value });
        break;
      }
      default:
        break;
    }
  };

  onKeyUp = e => {
    const { success } = this.state;
    if (success) {
      this.setState({ success: false });
    }
    if (e.keyCode === 13) {
      this.singupUser();
    }
  };

  validateInputs = () => {
    const { fullName, companyName, domainName, email, phoneNumber } = this.state;
    const status = {};
    if (!fullName) {
      status.field = SignUpFields.NAME;
      status.error = SignUpErrors.REQUIRED;
      this.setState({ fieldStatus: status });
      return false;
    }
    if (!email) {
      status.field = SignUpFields.EMAIL;
      status.error = SignUpErrors.REQUIRED;
      this.setState({ fieldStatus: status });
      return false;
    }
    if (!isEmail(email)) {
      status.field = SignUpFields.EMAIL;
      status.error = SignUpErrors.INVALID_EMAIL;
      this.setState({ fieldStatus: status });
      return false;
    }
    // if (!validateEmail(email)) {
    //   status.field = SignUpFields.EMAIL;
    //   status.error = SignUpErrors.INVALID_EMAIL;
    //   this.setState({ fieldStatus: status });
    //   return false;
    // }
    if (!companyName) {
      status.field = SignUpFields.COMPANY;
      status.error = SignUpErrors.REQUIRED;
      this.setState({ fieldStatus: status });
      return false;
    }
    if (!domainName) {
      status.field = SignUpFields.DOMAIN;
      status.error = SignUpErrors.REQUIRED;
      this.setState({ fieldStatus: status });
      return false;
    }
    if (!phoneNumber) {
      status.field = SignUpFields.NUMBER;
      status.error = SignUpErrors.REQUIRED;
      this.setState({ fieldStatus: status });
      return false;
    }
    if (!validateNumber(phoneNumber)) {
      status.field = SignUpFields.NUMBER;
      status.error = SignUpErrors.INVALID_NUMBER;
      this.setState({ fieldStatus: status });
      return false;
    }
    return true;
  };

  singupUser = () => {
    if (!this.validateInputs()) return;
    this.setState({ loading: true });
    const { fullName, companyName, domainName, email } = this.state;
    const url = globalURL.awsEndpoint + '/api/createCompany';
    const finalData = {};
    finalData.name = companyName;
    finalData.adminEmail = email;
    finalData.adminName = fullName;
    finalData.description = '';
    finalData.logo =
      'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/images/company/lyearn-logo2x.png';
    finalData.backGround =
      'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/images/company/sprinklr/backGround.jpg';
    finalData.loginTypes = ['EMAIL_LOGIN', 'GOOGLE_LOGIN'];
    finalData.headerImage =
      'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/images/lyearn_university.png';
    finalData.requiredContent = false;
    finalData.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    finalData.adminUniqueId = email;
    finalData.showCompanyDetails = false;
    finalData.subDomain = domainName;
    fetch(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(finalData)
    })
      .then(response => response.json())
      .then(() => {
        this.setState({ loading: false, success: true });
      })
      .catch(err => {
        console.log('error', err);
        this.setState({ loading: false });
      });
  };

  renderActivityIndicator = (width, height, inButton) => {
    if (inButton) {
      return (
        <ActivityIndicator
          width={width}
          height={height}
          style={{ marginRight: '6px', fill: '#fff' }}
          svgColor="#fff"
        />
      );
    }
    return <ActivityIndicator width={width} height={height} />;
  };

  renderSignupWrapper = () => {
    const {
      fullName,
      companyName,
      loading,
      domainName,
      email,
      phoneNumber,
      fieldStatus,
      success
    } = this.state;
    const { field, error } = fieldStatus;
    let icon = '';
    let numberErrorMessage = '';
    let signUpText = 'SIGN UP FOR FREE';
    if (loading) {
      signUpText = 'SIGNING UP';
    }
    if (success) {
      signUpText = 'SIGNUP SUCCESSFUL';
    }
    // if (field === SignUpFields.EMAIL && error === SignUpErrors.REQUIRED) {
    //   emailErrorMessage = <div>&nbsp;</div>;
    // } else if (field === SignUpFields.EMAIL && error === SignUpErrors.INVALID_EMAIL) {
    //   emailErrorMessage = 'Please enter valid email';
    // }
    if (field === SignUpFields.NUMBER && error === SignUpErrors.REQUIRED) {
      numberErrorMessage = <div>&nbsp;</div>;
    } else if (field === SignUpFields.NUMBER && error === SignUpErrors.INVALID_NUMBER) {
      numberErrorMessage = 'Please enter valid number';
    }
    if (loading) {
      icon = this.renderActivityIndicator(16, 16, true);
    }
    return (
      <Column>
        <CustomIconInput
          placeholder="Full Name"
          value={fullName}
          onChange={this.onFieldChange(SignUpFields.NAME)}
          wrapperProps={{ style: { background: 'white' } }}
          onKeyUp={this.onKeyUp}
          error={
            field === SignUpFields.NAME && error === SignUpErrors.REQUIRED ? (
              <div>&nbsp;</div>
            ) : null
          }
        />
        <CustomIconInput
          placeholder="Work Email"
          value={email}
          onKeyUp={this.onKeyUp}
          onChange={this.onFieldChange(SignUpFields.EMAIL)}
          wrapperProps={{ style: { marginTop: '8px', background: 'white' } }}
          error={
            field === SignUpFields.EMAIL &&
            (error === SignUpErrors.REQUIRED || error === SignUpErrors.INVALID_EMAIL) ? (
              <div>&nbsp;</div>
            ) : null
          }
        />
        <CustomIconInput
          placeholder="Company"
          value={companyName}
          onKeyUp={this.onKeyUp}
          onChange={this.onFieldChange(SignUpFields.COMPANY)}
          wrapperProps={{ style: { marginTop: '8px', background: 'white' } }}
          error={
            field === SignUpFields.COMPANY && error === SignUpErrors.REQUIRED ? (
              <div>&nbsp;</div>
            ) : null
          }
        />
        <DomainWrapper>
          <CustomIconInput
            placeholder="LMS Domain Name"
            value={domainName}
            onKeyUp={this.onKeyUp}
            onChange={this.onFieldChange(SignUpFields.DOMAIN)}
            wrapperProps={{ style: { background: 'white' } }}
            error={
              field === SignUpFields.DOMAIN && error === SignUpErrors.REQUIRED ? (
                <div>&nbsp;</div>
              ) : null
            }
          />
          <FixText>.lyearn.com</FixText>
        </DomainWrapper>
        <CustomIconInput
          placeholder="Phone Number"
          value={phoneNumber}
          onKeyUp={this.onKeyUp}
          onChange={this.onFieldChange(SignUpFields.NUMBER)}
          wrapperProps={{ style: { marginTop: '8px', background: 'white' } }}
          error={numberErrorMessage}
        />
        <SquareBorderButton
          text={signUpText}
          onClick={this.singupUser}
          type="filled"
          disabled={loading}
          icon={icon}
          iconPosition="left"
          style={{ width: '202px', borderRadius: '100px', margin: '34px 14px' }}
          status={success ? 'success' : 'normal'}
        />
        <ContactLyearnText tcText={true}>
          By signing up, you agree to T&C and Privacy Policy
        </ContactLyearnText>
      </Column>
    );
  };

  render() {
    return (
      <CompanyPageWrapper>
        <Heading>Great Choice! Start your free trail account now.</Heading>
        <IntroText>Fill the details below:</IntroText>
        <FixWidthColumn>{this.renderSignupWrapper()}</FixWidthColumn>
        <ContactLyearnText tcText={false}>
          Not able to sign up? Please reach out to us at... &nbsp;
          <a href="mailto:contact@lyearn.com">contact@lyearn.com</a>
        </ContactLyearnText>
      </CompanyPageWrapper>
    );
  }
}
